import reducer from './reducer';
import * as constants from './constants';

export default { reducer, constants };
